import { ProjectCustomerEmailItemDTO } from '../../domain/project/ProjectDTO';
import { ProjectCustomerEmailItem } from '../../domain/project/projectCustomerEmail/ProjectCustomerEmailItem';

export class ProjectCustomerEmailItemMapper {
  static toDomain(props: ProjectCustomerEmailItemDTO): ProjectCustomerEmailItem {
    const { from, enabled, subject, body, updated_at, pod_fields } = props;

    return ProjectCustomerEmailItem.create({
      from,
      enabled,
      subject,
      body,
      updated_at,
      pod_fields,
    });
  }

  static toRepository(smsMessage: ProjectCustomerEmailItem): ProjectCustomerEmailItemDTO {
    return {
      from: smsMessage.from,
      enabled: smsMessage.enabled,
      subject: smsMessage.subject,
      body: smsMessage.body,
      ...(smsMessage.pod_fields ? { pod_fields: smsMessage.pod_fields } : {}),
    };
  }
}
